import { gql } from "@apollo/client";

export const GET_TIPO_PROFESIONAL_BY_ID_PLAN_CUIDADO = gql`
  query getTipoProfesionalByIdPlanCuidado($idPlanCuidado: Int!) {
    tipoProfesionalByIdPlanCuidado(idPlanCuidado: $idPlanCuidado) {
      idTipoProfesional
      descripcion
    }
  }
`;